'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var $carousel = $('[data-slick]');

    if ($carousel.length) {
        var multipleSlides = $carousel[0].childElementCount > 1;
        $carousel.on('init', function (event, slick) {
            if (slick.$dots) {
                var slideText = slick.currentSlide + 1;
                if (slideText < 10) slideText = '0' + slideText;
                var slideCount = slick.slideCount;
                if (slideCount < 10) slideCount = '0' + slideCount;
                slick.$dots.attr('data-current', slideText).attr('data-total', slideCount);
            }
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (slick.$dots) {
                var slideText = nextSlide + 1;
                if (slideText < 10) slideText = '0' + slideText;
                slick.$dots.attr('data-current', slideText);
            }
        }).slick({
            dots: multipleSlides
        });
    }

    // Alternative image styling for IE, which doesn't support objectfit
    if (typeof document.documentElement.style.objectFit === 'undefined') {
        $('.heroCarousel-slide').each(function (index, element) {
            var $container = $(element);
            var imgUrl = $container.find('img').data('lazy');

            if (imgUrl) {
                $container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
            }
        });
    }
};

require('slick-carousel');